var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_205",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_205",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAixJREFUWAntlj0vQ2EUx11vkYhoUoPo0FFCJEJiMehASNrB0IGwiYTP4AvwBRiwWIwGhjIQDCyY7CwMXhYxCfX713Pl3kfbe6taAyf59Xk553/O6X2vqfm3v34EHB2AbDbbwDAGUa2rYA/UyDiO8+JQPMViA87gHqphbRTph2n9+z24gRWoq3R11YBlUM1dNfAKMTiCHWiuVBPKDdtwDKr5WksxoXMyAk+gRtoZf9RMzkOSPsMwqGatjoCsiYXmuiYW4Qq6tPcTplwm5xKje+E3Mc/6GnCLsT8Hd5Bw9747KofJNefNwV7hBhRIQBIeYNorLGWOdsrkSNo69os3IAFBfaCrdcFOELSWxmh1u30xfMENSEVgHC5hDeq/ZLI2FAOrIE3ccn8u8YVrQAqCI7APGWj5zGJN5DMxB4wRy+1b4g/fgJQIGmEL9M9ivmwf/g7jU0yj7bfXxOQa0DMgrPUSOAjncEKCHldo5qesL0Axig1niGW550AhBf4E3ENaMYwz8AjrBs1njC/NXLEJrQsZ/nCngMAU6HYc9SZjHYV5g+8tqliQRi+6vIYvuAGCJkAPJB3Wkkwao53IJ8RXvAECZuEWwp9Pq5K0Jses5dJpLNwAzgG4hk5bWOpaOUyuAa+WvaIN6JZr9QrKmSsX+G7Nog2UUyys1m1Az4E3KOV5ELZGUFyutn4yMB4UXQG/amb0ATLEZBMuoZofpd3Um3S/Tn7ts5wm/u2PH4F32P15IIJomBsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4de1723c1fc8942e0176702b5b7e86f9.svg";
export { ForwardRef as ReactComponent };